import {
  GET_LIST_CONTENT_MANAGEMENT_REQUEST,
  GET_LIST_CONTENT_MANAGEMENT_SUCCESS,
  GET_LIST_CONTENT_MANAGEMENT_FAIL,
  GET_DETAIL_CONTENT_MANAGEMENT_REQUEST,
  GET_DETAIL_CONTENT_MANAGEMENT_SUCCESS,
  GET_DETAIL_CONTENT_MANAGEMENT_FAIL,
  CREATE_CONTENT_MANAGEMENT_REQUEST,
  CREATE_CONTENT_MANAGEMENT_SUCCESS,
  CREATE_CONTENT_MANAGEMENT_FAIL,
  UPDATE_CONTENT_MANAGEMENT_REQUEST,
  UPDATE_CONTENT_MANAGEMENT_SUCCESS,
  UPDATE_CONTENT_MANAGEMENT_FAIL,
  DELETE_CONTENT_MANAGEMENT_REQUEST,
  DELETE_CONTENT_MANAGEMENT_SUCCESS,
  DELETE_CONTENT_MANAGEMENT_FAIL
} from '../../constants/content-management/index'

const initialState = {
  loading: false,
  loadingCrud: false,
  contentManagementList: [],
  contentManagementDetail: {},
  pageable: {
    page: 1,
    size: 10,
    hits: 1
  },
  error: null
}

const contentManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_CONTENT_MANAGEMENT_REQUEST:
      return { ...state, loading: true }
    case GET_LIST_CONTENT_MANAGEMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        contentManagementList: action.payload,
        pageable: action.pageable
      }
    case GET_LIST_CONTENT_MANAGEMENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        contentManagementList: [],
        pageable: {
          page: 1,
          size: 10
        }
      }
    case GET_DETAIL_CONTENT_MANAGEMENT_REQUEST:
      return { ...state, loading: true, error: false }
    case GET_DETAIL_CONTENT_MANAGEMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        contentManagementDetail: action.payload,
        error: false
      }
    case GET_DETAIL_CONTENT_MANAGEMENT_FAIL:
      return { ...state, loading: false, error: action.payload }
    case CREATE_CONTENT_MANAGEMENT_REQUEST:
    case UPDATE_CONTENT_MANAGEMENT_REQUEST:
    case DELETE_CONTENT_MANAGEMENT_REQUEST:
      return { ...state, loadingCrud: true }
    case CREATE_CONTENT_MANAGEMENT_SUCCESS:
    case UPDATE_CONTENT_MANAGEMENT_SUCCESS:
    case DELETE_CONTENT_MANAGEMENT_SUCCESS:
      return { ...state, loadingCrud: false }
    case CREATE_CONTENT_MANAGEMENT_FAIL:
    case UPDATE_CONTENT_MANAGEMENT_FAIL:
    case DELETE_CONTENT_MANAGEMENT_FAIL:
      return { ...state, loadingCrud: false, error: action.payload }
    default:
      return state
  }
}

export default contentManagementReducer
